import React from 'react';
import { motion } from 'framer-motion';
import Call from '../components/Call';
import Footer from '../components/Footer';
import '../styles/project.css';

function Projects() {
  return (
    <motion.div 
      className='project-container'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div 
        className="project-container-text"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
      >
        <h2>Tell Us About Your Project – We’ll Handle the Rest!</h2>
        
        <motion.p 
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          At Nextcastle Energy Limited, we understand that every project is unique. That’s why we are committed to delivering tailored solutions that align with your specific requirements. Whether it’s oil and gas services, energy solutions, or engineering projects, our team is fully equipped to execute your vision with precision and efficiency.
        </motion.p>

        <motion.p 
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Got a project in mind? Share the details with us, and let’s make it happen! With our expertise, cutting-edge technology, and commitment to excellence, we ensure a smooth and successful execution—on time and within budget.
        </motion.p>

        <motion.p 
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.8 }}
        >
          No project is too complex. No challenge is too big. Trust us to bring your ideas to life with efficiency, professionalism, and industry-leading expertise.
        </motion.p>
      </motion.div>

      <Call />
      <Footer />
    </motion.div>
  );
}

export default Projects;
